import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { IContentPageResponse } from '@modeso/dgoods-lib-admin-fe/models/content.pages';
import { IContentBoxResponse, INewstickerResponse } from '@modeso/types__dgoods-products';
import { Observable } from 'rxjs';
import { InternationalTopUpOffersOrOperators } from '../models/international-top-up-offers-or-operators.interface';
import { InternationalTopUpRequestDto } from '../models/international-top-up.request.dto';
import { ShopProductsWithCategories } from '../models/shopProductsWithCategories.interface';
import { ProductsConfigService } from './../products.config';

@Injectable({ providedIn: 'root' })
export class ProductsService {
    private readonly server = '';
    private readonly microserviceName = 'products';
    private readonly productsRoute = '/';
    private readonly newstickerRoute = 'newsticker/';
    private readonly contentPagesRoute = 'contentpages/';
    private readonly spotlightsRoute = 'spotlights';
    private readonly readSpotlightRoute = '/read';
    private readonly contentBoxesRoute = 'contentboxes/';
    private readonly internationalTopUpLookupsRoute = 'international-topup/lookups';

    constructor(
        private readonly http: HttpClient,
        @Inject(ProductsConfigService) private readonly config,
    ) {
        this.server = config.apiGateway;
    }

    getShopProductsWithCategories(): Observable<ShopProductsWithCategories> {
        const url = `${this.server}${this.microserviceName}${this.productsRoute}`;
        return this.http.get<ShopProductsWithCategories>(url);
    }

    getNewsTicker(status: string): Observable<INewstickerResponse> {
        const url = `${this.server}${this.microserviceName}/${this.newstickerRoute}${status}`;
        return this.http.get<INewstickerResponse>(url);
    }
    public getAllContentPages() {
        const url = `${this.server}${this.microserviceName}${this.productsRoute}${this.contentPagesRoute}`;
        return this.http.get<IContentPageResponse[]>(url);
    }

    public getSpotlights() {
        const url = `${this.server}${this.microserviceName}${this.productsRoute}${this.spotlightsRoute}`;
        return this.http.get<any>(url);
    }

    public markSpotlightAsRead(spotlightId: string) {
        const url = `${this.server}${this.microserviceName}${this.productsRoute}${this.spotlightsRoute}${this.readSpotlightRoute}${this.productsRoute}${spotlightId}`;
        return this.http.post(url, {});
    }

    public getPublishedContentBox(productlineId: string) {
        const url = `${this.server}${this.microserviceName}${this.productsRoute}${this.contentBoxesRoute}productLine/${productlineId}`;
        return this.http.get<IContentBoxResponse>(url);
    }

    public lookupInternationalTopUps(
        body: InternationalTopUpRequestDto,
    ): Observable<InternationalTopUpOffersOrOperators> {
        const url = `${this.server}${this.internationalTopUpLookupsRoute}`;
        return this.http.post<InternationalTopUpOffersOrOperators>(url, body);
    }
}
